<template>
  <div
    id="omq-contact-container"
    data-omq-contact-account="https://flinkster.omq.de"
    :data-omq-contact-api-key="clientOmqMapping[locale as LocaleType][client]"
  />
</template>

<script setup lang="ts">
const { locale } = useI18n()
const config = useRuntimeConfig()
const client = config.public.client as ClientType
const clientOmqMapping = config.public.clientOmqMapping as ClientOmqMapping
useHead({
  script: [
    {
      src: 'https://flinkster.omq.de/contact/contact.min.js',
      type: 'text/javascript',
      tagPosition: 'bodyClose',
    },
  ],
})
</script>
